import React, {useEffect, useContext} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction} from "mobx";
import PropTypes from "prop-types";
import { ComponentContext } from "../../contexts";
import Button from "./WithSelected/Button";

function WithSelected(props) {
  const store = useLocalObservable(() => ({list: [], fetching: false, inited: false}));
  const compStore = useContext(ComponentContext);
  useEffect(() => {
    // mount

    return () => {
      // unmount
    }
  }, []);

  const presets= {
    delete_icon: {
      mdi: "trash-can-outline",
      type: "btn8",
      action: "delete",
      tooltip: "Удалить"
    },
    delete_btn: {
      mdi: "trash-can-outline",
      type: "btn8",
      action: "delete",
      title: "Удалить",
    },
    unselect_btn: {
      icon_only: false,
      type: "btn8",
      mdi:"close",
      action: "unselect",
      title: "Отмена",
      tooltip: "Отмена",
      condition:(items, item_by_id)=>{  return true; }
    },
    unknown: {
      icon_only: true,
      mdi: "close",
      action: "unknown",
      tooltip: "Пресет не найден"
    }
  };

  /*
      "preset"=>$this->preset,
			"mdi"=>$this->mdi,
			"add_class"=>$this->add_class,
			"add_btn_class"=>$this->add_btn_class,

			"set_url"=>$this->set_url,
			"open_in_iframe"=>$this->open_in_iframe,
			"on_click"=>$this->on_click,
			"title"=>$this->title,
			"danger"=>$this->danger,
			"iframe_action"=>$this->iframe_action,
			"conditions"=>$this->conditions,
   */

  const getButtonProps=(item)=>{
    if(typeof item === "string") {
      if(presets[item]) {
        return presets[item];
      } else {
        return presets.unknown;
      }
    } else {
      if(item.preset) {
        return {...presets[item.preset], ...item};
      } else {
        return item;
      }
    }
  };

  return (
    <div className={`pf pa-tl w100 bg-b3 w1 globalWithSelected trans03 ${compStore.getCount()>0?"visible":""} up12 splice`}>
      <div className="hpadd20 cell s-12 s-middle">
        <div className="up12 splice">
          <div className="cell s-shrink fs14 bold pright10 solid1-right w1 bo-w5 s-middle">
            Выбрано: {compStore.getCount()}
          </div>
          <div className="cell s-shrink s-middle pleft10 wsnw">
            {compStore.cur_layout.left.map((item, index)=>{
              return <Button className={"mright10"} key={index} {...getButtonProps(item)} />;
            })}
          </div>
          <div className="cell s-auto"></div>
          <div className="cell s-shrink s-middle pleft10 wsnw">
            {compStore.cur_layout.right.map((item, index)=>{
              return <Button className={"mleft10"} key={index} {...getButtonProps(item)} />;
            })}
          </div>
        </div>
      </div>
    </div>
  )
};

WithSelected.defaultProps = {};

WithSelected.propTypes = {}

export default observer(WithSelected);
